export default __webpack_public_path__ + "static/ArminGrotesk-UltraLight-e308dbe8101aaa64db0d0234cc2abde3.woff";